module.exports = __webpack_public_path__ + "static/img/coding.48829aa6.svg";